import { render, staticRenderFns } from "./Editais.vue?vue&type=template&id=1831cce1&scoped=true&lang=pug&"
import script from "./Editais.vue?vue&type=script&lang=js&"
export * from "./Editais.vue?vue&type=script&lang=js&"
import style0 from "./Editais.vue?vue&type=style&index=0&id=1831cce1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831cce1",
  null
  
)

export default component.exports